import React, { useMemo } from 'react';
import { Select } from '../../../../../../../components/Select/index';
import { BASE_CURRENCIES } from './constants';

const EsmaBaseCurrencyField = ({ fund, onChange, disabled }) => {
  const selectedBaseCurrencyValue = useMemo(() => {
    if (!fund.baseCurrency) return null;
    return { label: fund.baseCurrency, value: fund.baseCurrency };
  }, [fund.baseCurrency]);

  return (
    <Select
      value={selectedBaseCurrencyValue}
      options={BASE_CURRENCIES}
      getOptionValue={opt => opt.value}
      getOptionLabel={opt => opt.label}
      onChange={onChange}
      isDisabled={disabled}
      placeholder=""
      menuPortalTarget={document.body}
      menuPlacement="auto"
    />
  );
};

export default EsmaBaseCurrencyField;
